/**
 * `403 provider_contact_required`: a PLG partner's restaurant user reached a
 * decision the partner keeps for itself — whether and through which gateway the
 * restaurant takes online payments, going live, a paid licence. The body names
 * whom to ask:
 *
 *   { title, description, error_code, data: { provider: { name, support_email, support_phone_number } } }
 */
export const PROVIDER_CONTACT_REQUIRED = 'provider_contact_required';

/** One toast per refusal, however many screens or calls report it. */
export const PROVIDER_CONTACT_TOAST_ID = 'provider-contact-required';

export function isProviderContactRequired(body) {
  return body?.error_code === PROVIDER_CONTACT_REQUIRED;
}

const filled = (value) => typeof value === 'string' && value.trim().length > 0;

/** The partner's contact from the error body, with blank fields as null. */
export function providerContact(body) {
  const provider = body?.data?.provider ?? {};

  return {
    name: filled(provider.name) ? provider.name : null,
    email: filled(provider.support_email) ? provider.support_email : null,
    phone: filled(provider.support_phone_number) ? provider.support_phone_number : null,
  };
}

/** One line for a toast: the backend's (already localised) description plus the contact. */
export function providerContactMessage(body) {
  const { email, phone } = providerContact(body);
  const text = body?.description ?? body?.title ?? '';

  return [text, [email, phone].filter(Boolean).join(' · ')].filter(Boolean).join(' ');
}
